import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-advertaisement',
  templateUrl: './advertaisement.component.html',
  styleUrls: ['./advertaisement.component.css']
})
export class AdvertaisementComponent implements OnInit {

  imagesarray=[
    'assets/images/svg/heathrowad1.svg',
    'assets/images/svg/heathrowad2.svg',
    'assets/images/svg/heathrowad3.svg'
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
